import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { openGoogleForm } from '../utils/googleFormsHelper';

const EventIntakeForm = ({ isOpen, onClose, eventTitle }) => {
  const modalRef = useRef(null);

  // Add debugging
  useEffect(() => {
    console.log("EventIntakeForm rendered with isOpen:", isOpen);
    console.log("EventTitle:", eventTitle);
  }, [isOpen, eventTitle]);

  // Handle clicks outside the modal to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  // Handle escape key to close modal
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);

  // Don't render anything if the form is not open
  if (!isOpen) {
    console.log("Form not open, not rendering");
    return null;
  }

  console.log("Rendering form modal");
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 overflow-y-auto">
      <div className="relative w-full max-w-4xl mx-auto" ref={modalRef}>
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="p-4 flex justify-between items-center border-b">
            <h2 className="text-xl font-semibold text-gray-900">
              Register for {eventTitle || 'Event'}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 focus:outline-none"
              aria-label="Close"
            >
              <X size={20} />
            </button>
          </div>
          
          <div className="p-1 h-[80vh]">
            <iframe 
              src="https://docs.google.com/forms/d/e/1FAIpQLSehcilCV6ENmh2IkQVEVQ0kmk9f_ZPdYS6Nv0lV2xnw11R6Ag/viewform?embedded=true" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              marginHeight="0" 
              marginWidth="0"
              title="Event Registration Form"
              className="w-full h-full"
            >
              Loading form...
            </iframe>
          </div>
          
          <div className="p-4 border-t bg-gray-50">
            <div className="flex justify-end">
              <button
                onClick={onClose}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors mr-2"
              >
                Close
              </button>
              <button
                onClick={openGoogleForm}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Open in New Tab
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventIntakeForm; 